import useSearchStore from 'stores/SearchStoreV2';
import { MATCH_COMPANY_IDS } from 'util/constants';

const CauzeMatchBadge = ({ charity }) => {
  const searchStore = useSearchStore();

  const filteredTopics = searchStore.topics
    .filter((t) => t.companyId === MATCH_COMPANY_IDS.ALTMAN_SOLON)
    .map((t) => t.name);
  const hasMatch = filteredTopics.some((topicName) =>
    charity.topics?.includes(topicName),
  );

  if (!hasMatch) return <></>;

  return (
    <div className="flex w-12 bg-green-600 text-white font-agenda-bold text-xs rounded-md pt-[1px] leading-none h-5">
      <span className="leading-[20px] m-auto">MATCH</span>
    </div>
  );
};

export default CauzeMatchBadge;
